// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base Stat Block Styles */
.stat-block {
  text-align: left;
  font-family: Crimson, serif;
  font-size: 14px;
  line-height: 1em;
  display: inline-block;
  vertical-align: top;
  width: 400px;
  background: #fffbef;
  padding: 5px 10px 5px;
  border-radius: 2px;
  position: relative;
}

.stat-block * {
  font-family: Crimson, serif;
}

.stat-block.wide {
  width: 400px;
  min-height: 800px;
  display: flex;
}

.stat-block .section-left,
.stat-block .section-right {
  flex: 1 1;
  padding: 5px 10px 5px 10px;
  box-sizing: border-box;
}

.stat-block .section-left {
  border-right: 0px solid #924A40;
}

.straight-rule {
  display: block;
  width: 100%;
  height: 2px;
  border: none;
  color: #e8a823;
  fill: #e8a823;
  margin-top: 5px;     /* Add 5px space above the rule */
  margin-bottom: 5px;  /* Add 5px space below the rule */
}

.creature-heading {
  margin: 0 0 10px 0;
  font-family: Crimson, serif;
}

.creature-heading h1 {
  font-family: Crimson, serif;
  font-weight: 700;
  margin: 0;
  font-size: 24px;
  letter-spacing: 1px;
  color: #4d3914;
}

.creature-heading h2 {
  font-weight: normal;
  font-style: italic;
  font-size: 16px;
  margin: 0;
}

.property-line h4,
.property-line p {
  display: inline;
  margin: 0;
  font-weight: bold;
  font-size: 14px;
}

.property-line p {
  margin: 0;
  margin-left: 5px; /* Add space after the label */
  color: #000;
  font-weight: normal;
}

.property-block {
  padding: 0;  /* Fix the invalid negative padding */
  margin-bottom: 0.25em; /* Reduce space between blocks */
}

.property-block h4 {
  font-weight: bold;
  font-style: italic;
  display: inline;
  margin: 0;
  font-size: 16px; /* Add this line to reduce the font size */
}

.property-block p {
  margin-top: 0;
  margin-bottom: 0.3em; /* Reduce bottom margin specifically for property blocks */
}

.actions h3 {
  font-size: 20px;
  font-variant: small-caps;
  font-weight: normal;
  letter-spacing: 1px;
  margin: 20px 0px 10px 0;
  padding: 0 0 0px 0;
  text-indent: 0px;
}

.scores {
  margin: 10px 10px 0px 0;
  display: flex;
  justify-content: space-between;
}

.scores div {
  text-align: center;
  flex: 1 1;
}

.scores h4 {
  margin: 0;
  font-size: 14px; 
  font-weight: bold;
}

.scores p {
  margin: 0;
}

i, em {
  font-style: italic;
}

b, strong {
  font-weight: bold;
}

p {
  margin-top: 0.3em;
  margin-bottom: 0.9em;
}

.demo-controls {
  margin-bottom: 40px;
  background: #f5f5f5;
  padding: 20px;
  border-radius: 5px;
}

.file-upload {
  margin-bottom: 20px;
}

.file-upload label {
  display: block;
  margin-bottom: 8px;
}

.json-editor {
  margin-top: 20px;
}

.json-editor textarea {
  width: 100%;
  padding: 8px;
  font-family: monospace;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.update-button {
  background: #4a6fa5;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-family: Crimson, serif;
}

.update-button:hover {
  background: #385682;
}

.stat-block-display {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Add to Statblocker.css */
.passive-block {
  margin-top: 0.4em;  /* Reduced from 0.3em */
  margin-bottom: 0.4em;  /* Reduced from 0.9em */
}

/* Add specific styling for passive items that are adjacent */
.passive-block + .passive-block {
  margin-top: 0;  /* Remove top margin for consecutive passive blocks */
}

/* Adjust paragraph margins within passive blocks */
.passive-block p {
  text-indent: 0;
  margin: 0;
  line-height: 1.2;  /* Tighter line height */
}

.straight-rule {
  margin-top: 10px;
  margin-bottom: 13px;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Statblocker/Statblocker.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;;AAEA;;EAEE,SAAO;EACP,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,eAAe,MAAM,iCAAiC;EACtD,kBAAkB,GAAG,iCAAiC;AACxD;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gBAAgB,EAAE,8BAA8B;EAChD,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,UAAU,GAAG,qCAAqC;EAClD,qBAAqB,EAAE,gCAAgC;AACzD;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,eAAe,EAAE,0CAA0C;AAC7D;;AAEA;EACE,aAAa;EACb,oBAAoB,EAAE,0DAA0D;AAClF;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB,GAAG,uBAAuB;EAC3C,oBAAoB,GAAG,uBAAuB;AAChD;;AAEA,6DAA6D;AAC7D;EACE,aAAa,GAAG,qDAAqD;AACvE;;AAEA,mDAAmD;AACnD;EACE,cAAc;EACd,SAAS;EACT,gBAAgB,GAAG,wBAAwB;AAC7C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":["/* Base Stat Block Styles */\n.stat-block {\n  text-align: left;\n  font-family: Crimson, serif;\n  font-size: 14px;\n  line-height: 1em;\n  display: inline-block;\n  vertical-align: top;\n  width: 400px;\n  background: #fffbef;\n  padding: 5px 10px 5px;\n  border-radius: 2px;\n  position: relative;\n}\n\n.stat-block * {\n  font-family: Crimson, serif;\n}\n\n.stat-block.wide {\n  width: 400px;\n  min-height: 800px;\n  display: flex;\n}\n\n.stat-block .section-left,\n.stat-block .section-right {\n  flex: 1;\n  padding: 5px 10px 5px 10px;\n  box-sizing: border-box;\n}\n\n.stat-block .section-left {\n  border-right: 0px solid #924A40;\n}\n\n.straight-rule {\n  display: block;\n  width: 100%;\n  height: 2px;\n  border: none;\n  color: #e8a823;\n  fill: #e8a823;\n  margin-top: 5px;     /* Add 5px space above the rule */\n  margin-bottom: 5px;  /* Add 5px space below the rule */\n}\n\n.creature-heading {\n  margin: 0 0 10px 0;\n  font-family: Crimson, serif;\n}\n\n.creature-heading h1 {\n  font-family: Crimson, serif;\n  font-weight: 700;\n  margin: 0;\n  font-size: 24px;\n  letter-spacing: 1px;\n  color: #4d3914;\n}\n\n.creature-heading h2 {\n  font-weight: normal;\n  font-style: italic;\n  font-size: 16px;\n  margin: 0;\n}\n\n.property-line h4,\n.property-line p {\n  display: inline;\n  margin: 0;\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.property-line p {\n  margin: 0;\n  margin-left: 5px; /* Add space after the label */\n  color: #000;\n  font-weight: normal;\n}\n\n.property-block {\n  padding: 0;  /* Fix the invalid negative padding */\n  margin-bottom: 0.25em; /* Reduce space between blocks */\n}\n\n.property-block h4 {\n  font-weight: bold;\n  font-style: italic;\n  display: inline;\n  margin: 0;\n  font-size: 16px; /* Add this line to reduce the font size */\n}\n\n.property-block p {\n  margin-top: 0;\n  margin-bottom: 0.3em; /* Reduce bottom margin specifically for property blocks */\n}\n\n.actions h3 {\n  font-size: 20px;\n  font-variant: small-caps;\n  font-weight: normal;\n  letter-spacing: 1px;\n  margin: 20px 0px 10px 0;\n  padding: 0 0 0px 0;\n  text-indent: 0px;\n}\n\n.scores {\n  margin: 10px 10px 0px 0;\n  display: flex;\n  justify-content: space-between;\n}\n\n.scores div {\n  text-align: center;\n  flex: 1;\n}\n\n.scores h4 {\n  margin: 0;\n  font-size: 14px; \n  font-weight: bold;\n}\n\n.scores p {\n  margin: 0;\n}\n\ni, em {\n  font-style: italic;\n}\n\nb, strong {\n  font-weight: bold;\n}\n\np {\n  margin-top: 0.3em;\n  margin-bottom: 0.9em;\n}\n\n.demo-controls {\n  margin-bottom: 40px;\n  background: #f5f5f5;\n  padding: 20px;\n  border-radius: 5px;\n}\n\n.file-upload {\n  margin-bottom: 20px;\n}\n\n.file-upload label {\n  display: block;\n  margin-bottom: 8px;\n}\n\n.json-editor {\n  margin-top: 20px;\n}\n\n.json-editor textarea {\n  width: 100%;\n  padding: 8px;\n  font-family: monospace;\n  margin-bottom: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.update-button {\n  background: #4a6fa5;\n  color: white;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-family: Crimson, serif;\n}\n\n.update-button:hover {\n  background: #385682;\n}\n\n.stat-block-display {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* Add to Statblocker.css */\n.passive-block {\n  margin-top: 0.4em;  /* Reduced from 0.3em */\n  margin-bottom: 0.4em;  /* Reduced from 0.9em */\n}\n\n/* Add specific styling for passive items that are adjacent */\n.passive-block + .passive-block {\n  margin-top: 0;  /* Remove top margin for consecutive passive blocks */\n}\n\n/* Adjust paragraph margins within passive blocks */\n.passive-block p {\n  text-indent: 0;\n  margin: 0;\n  line-height: 1.2;  /* Tighter line height */\n}\n\n.straight-rule {\n  margin-top: 10px;\n  margin-bottom: 13px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
